import React from 'react';
const api = new API();
import API from "../../api";
import {NavLink} from "react-router-dom";
import * as moment from "moment";
import {images} from "../../constant";
import CommonStaticSidebar from "./commonStaticSidebar";
import BestSellerGrid from "./bestSellerGrid";
import ReactPaginate from "react-paginate";
import {Helmet} from "react-helmet";
import {BASE_URL} from "../../helper";

class Articles extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            total_pages : null,
            blogs: [],
        }
    }

    static async getInitialProps({req, res, match, history, location, ...ctx}) {
        const articles = await api.getAllBlog(1);
        return {
            total_pages : articles ? articles?.headers?.['x-wp-totalpages'] : null,
            blogs : articles ? articles?.data : []
        }
    }

    handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        api.getAllBlog(pageNumber.selected + 1).then(blogs => {
            this.setState({
                total_pages : blogs ? blogs?.headers?.['x-wp-totalpages'] : null,
                blogs : blogs.data
            });
        });
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        api.getAllBlog(this.state.total_pages ? this.state.total_pages : 1 ).then(blogs => {
            this.setState({
                total_pages : blogs ? blogs?.headers?.['x-wp-totalpages'] : null,
                blogs : blogs.data
            });
        });
    }

    render() {

        const blogs = this.state.blogs ? this.state.blogs : this.props.blogs ;

        return (
            <React.Fragment>
                <>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - Articles & Recipes</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        <script type="application/ld+json" className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                    </Helmet>
                    <div className="about-banner">
                        <div className="image-wrap">
                            <div className="img-content">
                                <img
                                    src={images.about}
                                    alt="Not Found"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="overlay"></div>
                        </div>
                        <div className="banner-content">
                            <h1 >Articles & Recipes</h1>
                            <h5>Check out our latest hand-crafted articles from Houston's best butcher shop, Farmer's Fresh Meat</h5>
                        </div>
                    </div>
                    <div className="container-fluid about-content mt-3 mb-fix">
                        <div className="col-12">
                            <div className="row">
                                <CommonStaticSidebar />
                                <div className="col-md-9 emp-form article-list-view">
                                    {/*<div className="mb-0">*/}
                                    {/*    <h2 className="main-head">Category name</h2>*/}
                                    {/*</div>*/}
                                    <div className="row">
                                        {blogs.length > 0 ? blogs.map((blog, index) => {

                                            const image = blog["_embedded"]["wp:featuredmedia"]?.[0]["media_details"]  ?  blog["_embedded"]?.["wp:featuredmedia"]?.[0]?.["media_details"]?.["sizes"]?.["medium"]?.["source_url"] : images.blog_place ;
                                            const sort_description = blog["acf"]["short_description"];

                                            return (
                                                <>
                                                    <div key={index} className="col-12 col-md-6 food-column article-card px-md-2 px-0 mb-3">
                                                        <NavLink exact to={"/blog/" + blog.slug}>
                                                            <a>
                                                                <div className="col-12 product-details p-md-3 p-0">
                                                                    <div className="row align-items-center">
                                                                        <div className="col-5 pr-0">
                                                                            <img className="img-fluid" src={image}/>
                                                                        </div>
                                                                        <div className="col-7">
                                                                            <p className="d-flex align-items-center justify-content-between text-uppercase mb-0 text-theme font-10 mb-0 h-auto"><span className="text-capitalize text-muted">{ moment(new Date(blog.date)).format('LL')}</span></p>
                                                                            <h6 className="my-1 align-items-start">{blog.title?.rendered}</h6>
                                                                            <p>{sort_description}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </NavLink>
                                                    </div>
                                                </>
                                            )
                                        }) :
                                            <div className="py-3 blank-banner">
                                                <img src={images.order_food}/>
                                                <h2 className="mt-3 mb-1">Related blog not found</h2>
                                            </div>
                                        }

                                        { ( this.state.total_pages ? this.state.total_pages : this.props.total_pages ) > 1 ?
                                            <div className="pagination">
                                                <ReactPaginate
                                                    previousLabel={<i className="fas fa-chevron-left"></i>}
                                                    nextLabel={<i class="fas fa-chevron-right"></i>}
                                                    pageCount={this.state.total_pages}
                                                    onPageChange={this.handlePageChange.bind(this)}
                                                    marginPagesDisplayed={0}
                                                    pageRangeDisplayed={5}
                                                    containerClassName={'paginationBttns'}
                                                    previousLinkClassName={'previousBttn'}
                                                    nextLinkClassName={'nextBttn'}
                                                    disabledClassName={'paginationDisabled'}
                                                    activeClassName={'paginationActive'}
                                                />
                                            </div>
                                            : ""}

                                        <div className="col-12 text-center title pl-3 mb-3 mt-3 d-none">
                                            <h2 className="main-head">Checkout Our Bestsellers</h2>
                                            <BestSellerGrid />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

            </React.Fragment>
        );
    }
}
export default Articles;

